module.exports = __webpack_public_path__ + "img/frame (91).770f7f2f.jpg";